module.exports = __webpack_public_path__ + "img/campus-ex-titlebg.f1ff38fc.jpeg";